module.exports = __webpack_public_path__ + "static/icon-smartphone-2d08848fcff68143e23d331ff608c172.png";